// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"df9ceacb","43":"0e1d7ab9","251":"ff4d2093","458":"b6e9d701","524":"02071883","547":"0a147633","730":"7a507f6f","746":"e2de8fcb"}[chunkId] + ".chunk.js";
};